module.exports = __webpack_public_path__ + "media/images/plans/photo_location/photo_location-1-1-3d7699c7b756e10dabfc89aaa4c57b07.png";